import React from 'react';

const Logo = () => {
  return (
    <div className="pl-8">
      <a href="/" className="pr-6 ">
        <div className="flex items-center gap-2">
          <img
            src="/agency/assets/workfall-logo.svg"
            alt="workfall logo"
            className=" h-[28px]"
          />
          <span className="logo-text text-xl md:text-2xl  mt-1 text-primary ">
            Workfall
          </span>
        </div>
      </a>
    </div>
  );
};

export default Logo;
